import React from "react";
import {startOfDay} from "date-fns";
import {longString} from "../../../services/date/formatters";
import {isValidDateObject} from "../../../services/date/validators";

import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import {DatePicker} from "@mui/x-date-pickers";
import Slider from "@mui/material/Slider";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import SettingsIcon from "@mui/icons-material/Settings";
import Box from "@mui/material/Box";

const maxValue = 500;
const minValue = 100;

const numberOfMarks = 5;
const stepSize = 50;


const PricePanel = ({ formik }) => {
    const [max, changeMax] = React.useReducer((state, action) => action === "increase" ? state + stepSize : state - stepSize, minValue);

    const step = Math.floor(max / numberOfMarks);

    const marks = Array.from({length: numberOfMarks}, (_, i) => step + i * step).map(value => ({
        value,
        label: `${value} €`
    }));

    const dateFromText = isValidDateObject(formik.values.dateFrom) ? longString(formik.values.dateFrom) : "gg/mm/aaaa";
    const dateToText = isValidDateObject(formik.values.dateTo) ? longString(formik.values.dateTo) : "gg/mm/aaaa";

    return <Stack direction="column" spacing={4} height="550px">
        <Typography textAlign="justify">
            Seleziona il periodo e il range di prezzi e in automatico verranno generati i
            prezzi per ogni giorno in base alla domanda e alla stagionalità.
            Potrai modificare i prezzi in qualsiasi momento. Ti conigliamo ti selezionare
            un'intera stagione.
        </Typography>

        <Stack direction="row" spacing={2}>
            <DatePicker value={formik.values.dateFrom}
                        onChange={date => formik.setFieldValue("dateFrom", startOfDay(date))}
                        disablePast
                        label="Periodo da"
                        closeOnSelect
                        disableHighlightToday
                        showDaysOutsideCurrentMonth
                        slotProps={{
                            textField: {
                                fullWidth: true,
                                required: true,
                                error: Boolean(formik.touched.dateFrom) && Boolean(formik.errors.dateFrom),
                                helperText: formik.touched.dateFrom && formik.errors.dateFrom
                            }
                        }}/>

            <DatePicker value={formik.values.dateTo}
                        onChange={date => formik.setFieldValue("dateTo", startOfDay(date))}
                        disablePast
                        minDate={formik.values.dateFrom}
                        defaultCalendarMonth={isValidDateObject(formik.values.dateFrom) ? formik.values.dateFrom : undefined}
                        label="Periodo a"
                        closeOnSelect
                        disableHighlightToday
                        showDaysOutsideCurrentMonth
                        slotProps={{
                            textField: {
                                fullWidth: true,
                                required: true,
                                error: Boolean(formik.touched.dateTo) && Boolean(formik.errors.dateTo),
                                helperText: formik.touched.dateTo && formik.errors.dateTo
                            }
                        }}/>
        </Stack>
        <Typography>
           Seleziona il prezzo minimo e massimo per il periodo {dateFromText} - {dateToText}.
            <Typography component="span" fontWeight={600}>Il prezzo è per persona a notte.</Typography>
        </Typography>
        <Stack direction="row" spacing={2} pt={4} justifyContent="center" alignItems="flex-start">
            <Slider
                min={10}
                max={max}
                marks={marks}
                valueLabelDisplay="on"
                getAriaLabel={() => 'Range di prezzi'}
                value={[formik.values.minPriceCent / 100, formik.values.maxPriceCent / 100]}
                onChange={(event, newValue) => {
                    formik.setFieldValue('minPriceCent', newValue[0] * 100);
                    formik.setFieldValue('maxPriceCent', newValue[1] * 100);
                }}
                getAriaValueText={(value) => `${value} €`}
                valueLabelFormat={(value) => `${value} €`}
            />
            <Stack>
                <IconButton onClick={() => changeMax("increase")} disabled={max >= maxValue} sx={{p: 0}}>
                    <AddIcon/>
                </IconButton>
                <IconButton onClick={() => changeMax("decrease")} disabled={max <= minValue} sx={{p: 0}}>
                    <RemoveIcon/>
                </IconButton>
            </Stack>
        </Stack>

        <Box mt="auto!important">
            <Typography variant="body2" textAlign="justify">
                Verranno applicate le condizioni di pernottamento in base alla stagionalità alta/media/bassa. Puoi
                modificarle cliccando sull'icona <SettingsIcon sx={{fontSize: "1.2em"}}/> in alto a destra.
            </Typography>
        </Box>

    </Stack>
}

export default PricePanel;